import { render, staticRenderFns } from "./examineDetails.vue?vue&type=template&id=16e8537e&scoped=true&"
import script from "./examineDetails.vue?vue&type=script&lang=js&"
export * from "./examineDetails.vue?vue&type=script&lang=js&"
import style0 from "./examineDetails.vue?vue&type=style&index=0&id=16e8537e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e8537e",
  null
  
)

export default component.exports